document.addEventListener('DOMContentLoaded', function () {
  var burger = document.querySelector('.slvje-burger');
  var nav = document.querySelector('.slvje-nav');
  var overlay = document.querySelector('.slvje-nav-overlay');
  var closeBtn = document.querySelector('.slvje-nav-close');

  if (!burger || !nav) return;

  function closeSubmenus() {
    nav.querySelectorAll('.slvje-submenu-toggle').forEach(function (toggle) {
      toggle.setAttribute('aria-expanded', 'false');
    });
    nav.querySelectorAll('.slvje-submenu').forEach(function (submenu) {
      submenu.classList.remove('is-open');
    });
  }

  function openNav() {
    nav.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    burger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function closeNav() {
    nav.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    burger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    closeSubmenus();
  }

  burger.addEventListener('click', function () {
    if (nav.classList.contains('is-open')) {
      closeNav();
    } else {
      openNav();
    }
  });

  nav.querySelectorAll('.slvje-submenu-toggle').forEach(function (toggle) {
    toggle.addEventListener('click', function () {
      var submenu = document.getElementById(toggle.getAttribute('aria-controls'));
      if (!submenu) return;

      var willOpen = toggle.getAttribute('aria-expanded') !== 'true';
      closeSubmenus();
      toggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      submenu.classList.toggle('is-open', willOpen);
    });
  });

  if (overlay) overlay.addEventListener('click', closeNav);
  if (closeBtn) closeBtn.addEventListener('click', closeNav);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeNav();
  });

  nav.querySelectorAll('a').forEach(function (link) {
    link.addEventListener('click', closeNav);
  });
});
